import { makeStyles } from '@material-ui/core/styles';
import getBrand from '../../utils/getBrand';

const isCelebrity = getBrand()?.id === 'cel';

const useStyles = makeStyles((Theme) => ({
  rootFormReservation: {
    fontFamily: Theme.typography.base.regular,
    '& .MuiOutlinedInput-input': {
      marginBottom: '3px',
    },
    '& .MuiOutlinedInput-root': {
      height: '50px',

      '& legend': {
        display: 'none',
      },
      '& svg': {
        color: Theme.palette.primary.light,
      },
      '&.Mui-disabled svg': {
        color: Theme.palette.blackScale.opacity,
      },
    },
    '& .MuiGrid-grid-sm-6': {
      marginTop: '40px',
      [Theme.breakpoints.up('sm')]: {
        flexBasis: '48.8%',
      },

      [Theme.breakpoints.down('xs')]: {
        '&:first-child': {
          marginTop: '8px',
        },
        marginTop: '24px',
      },

      '& .MuiFormControl-root': {
        width: '100%',
      },
    },

    '& .MuiGrid-grid-sm-6:nth-of-type(2)': {
      [Theme.breakpoints.down(598)]: {
        marginTop: '30px',
      },
    },

    '& .MuiFormHelperText-root': {
      marginLeft: 0,
    },

    '& .MuiFormLabel-root.Mui-focused': {
      color: Theme.palette.gray[400],
    },

    '& legend': {
      color: Theme.palette.gray[750],
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[1],
    },

    '& .select-custom-field-error.MuiBox-root': {
      borderColor: Theme.palette.error.main,
      '& + .MuiFormHelperText-root': {
        fontFamily: Theme.typography.base.regular,
        color: Theme.palette.error.text,
        fontSize: Theme.typography.size[0.5],
        margin: '4px 0 0 0',
      },
      '& .MuiOutlinedInput-root svg': {
        color: Theme.palette.error.main,
      },
    },
  },

  flightsInput: {
    '& .MuiFormLabel-root': {
      fontFamily: Theme.typography.base.regular,
    },
    '& ul > li': {
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[2],
    },
    '& .MuiInputBase-input': {
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[2],
    },
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[1],
    '& label': {
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[1],
    },
    '& svg': {
      fill: Theme.palette.primary.light,
    },
    '&.field-error': {
      '& .MuiInputBase-root': {
        borderColor: Theme.palette.error.main,
      },
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontFamily: Theme.typography.base.regular,
      color: Theme.palette.error.text,
      fontSize: Theme.typography.size[0.5],
    },
  },

  textField: {
    [Theme.breakpoints.down('xs')]: {
      marginTop: '24px',
    },
    '& input': {
      color: `${Theme.palette.gray[750]} !important`,
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[2],
      lineHeight: '125%',
      '&::placeholder': {
        color: Theme.palette.gray[400],
        opacity: 1,
      },
    },
    '& .MuiFormLabel-root.Mui-error': {
      color: Theme.palette.gray[750],
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontFamily: Theme.typography.base.regular,
      color: Theme.palette.error.text,
      fontSize: Theme.typography.size[0.5],
    },
  },

  mainContainer: {
    padding: '24px',
    justifyContent: 'space-between',

    [Theme.breakpoints.up('md')]: {
      padding: '40px',
    },
  },

  styledLabel: {
    transform: 'unset !important',
    transition: 'unset !important',
    top: '-30px',
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[1],
    lineHeight: '125%',
    paddingBottom: 9,
    color: Theme.palette.gray[750],

    '&.Mui-focused': {
      color: 'inherit',
    },
  },

  dateInputs: {
    flexDirection: 'column',
    flexWrap: 'nowrap',
    '& > legend': {
      marginBottom: `${isCelebrity ? '3px' : '9px'}`,
    },
    '& .date-select-wrapper': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
    },

    '& .MuiGrid-grid-xs-4': {
      maxWidth: '31%',
      flexBasis: '31%',
    },
    '& .MuiGrid-grid-xs-4:last-child': {
      margin: 0,
    },

    '& .MuiGrid-root.MuiGrid-item': {
      '& legend': {
        display: 'none',
      },
    },

    '& .MuiSelect-root': {
      fontFamily: Theme.typography.base.regular,
    },

    '& .MuiGrid-item': {
      '& .MuiSelect-root': {
        paddingLeft: '20px',
      },

      [Theme.breakpoints.down('lg')]: {
        '& .MuiSelect-root': {
          paddingLeft: '10px',
        },
      },
    },
    '& .MuiOutlinedInput-input': {
      marginBottom: 0,
    },
  },

  footerForm: {
    backgroundColor: Theme.palette.gray[150],
    borderRadius: `${isCelebrity ? '0' : '0 0 4px 4px'}`,
    height: 80,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '16px 24px',
    [Theme.breakpoints.up('lg')]: {
      paddingRight: 40,
    },
    [Theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  // select props
  select: {
    backgroundColor: 'transparent !important',
    paddingLeft: 54,
    fontFamily: Theme.typography.base.regular,
    color: Theme.palette.gray[400],
    fontSize: Theme.typography.size[2],

    [Theme.breakpoints.down('lg')]: {
      paddingLeft: 44,
    },
  },

  menu: {
    backgroundColor: Theme.palette.white,
    '& ul > li': {
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[2],
    },
  },

  dateSelect: {
    paddingLeft: 10,
    color: Theme.palette.gray[400],
    fontSize: Theme.typography.size[2],
  },

  airpotRequiredError: {
    fontFamily: Theme.typography.base.regular,
    color: Theme.palette.error.text,
    fontSize: Theme.typography.size[0.5],
    marginTop: '4px',
  },
}));

export default useStyles;
